import { getCookie, cookiesAccepted } from '../cookies';
import { getCityValueForPageTracking, usesEfcTracking } from './delco-tracking';

export default class TrackingScript {
    constructor() {
        this.needsCookies = true;
    }

    async allowedInject(once = false) {
        // Skip cookie consent check if no cookies are needed
        if (!this.needsCookies) {
            return true;
        }

        return await this.allowedConsent(once);
    }

    async allowedConsent(once = false) {
        let consent = this.getConsent();

        if (!consent && once) {
            // No consent given and we are not going to wait for it
            return false;
        }

        // Wait for cookie consent given
        while (!consent) {
            await timeout(1);
            consent = this.getConsent();
        }

        return true;
    }

    getConsent() {
        return cookiesAccepted('analytics');
    }

    hasCookieConsentForNewBanner() {
        return getCookie('jet-consent-courierweb') !== null;
    }

    /**
     * This method gets the city value for tracking.
     * @returns {string} The city value.
     */
    getCityValue() {
        return getCityValueForPageTracking();
    }

    isCityPage() {
        return window.page === 'home_city';
    }

    isInsideTrack() {
        return window.pageGroup === 'courier_hub';
    }

    formatEnvironment(env) {
        // Exception for the Polish EFC market.
        if ((window.language?.isDelcoPage || usesEfcTracking()) && window.country?.code !== 'il') {
            // UK: https://elninotech.slack.com/archives/C02FQU82L3U/p1752844849767399
            // SK: https://elninotech.slack.com/archives/C09PWSJ5NJ2/p1762501756459969
            return (
                {
                    qa: 'staging',
                    prod: 'production',
                }[env] ?? env
            );
        }

        return env;
    }
}

function timeout(seconds) {
    return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
}
